export default __webpack_public_path__ + "static/media/LOGOTIPO HIPERFOCO SITE.3ca63a4a.png";